import {
  FETCH_CGU_CONTENT,
  UPDATE_CGU_CONTENT,
} from '../actions/types/cguContentTypes';
import {
  FAILED,
  STARTED,
  SUCCEEDED,
  getFailed,
  getStarted,
  getSucceeded,
} from '../../utils/helpers/store-helpers';

const initialState = {
  data: null,
  fetchStatus: '',
  updateStatus: '',
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getStarted(FETCH_CGU_CONTENT):
      return { ...state, fetchStatus: STARTED };
    case getFailed(FETCH_CGU_CONTENT):
      return { ...state, fetchStatus: FAILED };
    case getSucceeded(FETCH_CGU_CONTENT):
      return { ...state, data: payload, fetchStatus: SUCCEEDED };

    case getStarted(UPDATE_CGU_CONTENT):
      return { ...state, updateStatus: STARTED };
    case getFailed(UPDATE_CGU_CONTENT):
      return { ...state, updateStatus: FAILED };
    case getSucceeded(UPDATE_CGU_CONTENT):
      return { ...state, data: payload, updateStatus: SUCCEEDED };

    default:
      return state;
  }
};

export default reducer;
